var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EF463D;}\r\n\t.st1{fill:#427CBF;}\r\n\t.st2{fill:#00AF59;}\r\n\t.st3{fill:#DC2226;}\r\n\t.st4{fill:#FDB716;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.1,263.2c34.7,25.9,69.5,51.7,104.2,77.7c33.4,25,66.8,49.9,100,75.2c5,3.8,8.1,4,13.3,0.1 c65.7-49.6,131.6-98.9,197.5-148.3c2.2-1.6,4.5-3,6.8-4.6c0.1,4.4,0.2,8.8,0.2,13.2c0.1,71.4,0.1,142.8,0.2,214.2 c-0.2,0.5-0.3,0.9-0.5,1.4c-27.7,20.6-55.5,41.1-83.1,61.8c-40.4,30.2-80.8,60.5-121,91c-5.1,3.8-8.2,3.8-13.2-0.1 c-66.3-50.1-132.8-99.8-199.3-149.7c-1.5-1.1-3.2-2.1-4.8-3.1c-0.2-0.5-0.3-1-0.4-1.5C284,414.7,284.1,338.9,284.1,263.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284,490.5c0.1,0.5,0.2,1,0.4,1.5c-0.1,31-0.2,62.1-0.3,93.1c0,65.6-0.1,131.3,0.1,196.9c0,6.2-1.2,8.5-8,8.4 c-37.9-0.4-75.8-0.1-113.7-0.2c-30.9-0.1-54.3-22.9-54.4-53.2c-0.1-124.4,0-248.9,0-373.3c0-1.4,0.2-2.7,0.3-4.1 c2.9,2,5.9,4,8.7,6.1C172.8,407.3,228.4,448.9,284,490.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M705.8,492.1c0.2-0.5,0.3-0.9,0.5-1.4c13.6-10.1,27.3-20.2,40.9-30.4c44.8-33.5,89.6-67,134.4-100.4 c0.1,3.3,0.4,6.6,0.4,9.9c0,121.1,0,242.2,0,363.3c0,35.1-21.9,57.2-56.9,57.2c-36.5,0-73-0.3-109.6,0.2 c-8.3,0.1-9.7-2.4-9.6-10.1c0.3-92.8,0.2-185.6,0.2-278.5C706.1,498.6,705.9,495.4,705.8,492.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M284,490.5c-55.6-41.6-111.2-83.2-166.8-124.8c-2.8-2.1-5.8-4.1-8.7-6.1c0-26.8-2.1-53.8,0.8-80.5 c6.3-57.5,71.9-88.5,120.4-56.7c18.9,12.4,36.4,27.1,54.5,40.7C284.1,338.9,284,414.7,284,490.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M881.5,359.8c-44.8,33.5-89.6,67-134.4,100.4c-13.6,10.2-27.3,20.3-40.9,30.4c-0.1-71.4-0.1-142.8-0.2-214.2 c0-4.4-0.1-8.8-0.2-13.2c18.1-13.7,35.6-28.4,54.5-40.9c50.5-33.3,117.9,1.5,121.3,62.6C883.1,309.9,881.7,334.9,881.5,359.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.6d29fb7230525cd7ec01ac83eaad708e.svg";
export { ForwardRef as ReactComponent };